function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, props), React.createElement("path", {
    style: {
      "textIndent": 0,
      "textAlign": "start",
      "lineHeight": "normal",
      "textTransform": "none",
      "blockProgression": "tb",
      "InkscapeFontSpecification": "Bitstream Vera Sans"
    },
    d: "M 16 3 C 11.041484 3 7 7.0414839 7 12 C 7 13.406296 7.5697902 15.019621 8.34375 16.78125 C 9.1177098 18.542879 10.113372 20.412329 11.125 22.15625 C 13.148256 25.644091 15.1875 28.5625 15.1875 28.5625 L 16 29.75 L 16.8125 28.5625 C 16.8125 28.5625 18.851744 25.644091 20.875 22.15625 C 21.886628 20.412329 22.88229 18.542879 23.65625 16.78125 C 24.43021 15.019621 25 13.406296 25 12 C 25 7.0414839 20.958516 3 16 3 z M 16 5 C 19.877484 5 23 8.1225161 23 12 C 23 12.802704 22.56979 14.316192 21.84375 15.96875 C 21.11771 17.621308 20.113372 19.452421 19.125 21.15625 C 17.552794 23.866537 16.578771 25.299905 16 26.15625 C 15.421229 25.299905 14.447206 23.866537 12.875 21.15625 C 11.886628 19.452421 10.88229 17.621308 10.15625 15.96875 C 9.4302098 14.316192 9 12.802704 9 12 C 9 8.1225161 12.122516 5 16 5 z M 16 10 C 14.895431 10 14 10.895431 14 12 C 14 13.104569 14.895431 14 16 14 C 17.104569 14 18 13.104569 18 12 C 18 10.895431 17.104569 10 16 10 z",
    color: "#000",
    overflow: "visible",
    fontFamily: "Bitstream Vera Sans"
  }));
};

export default __webpack_public_path__ + "static/media/marker.61a66089.svg";
export { SvgComponent as ReactComponent };